// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.referral.UpdateReferralRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateReferralRequest extends GandalfModelBase {

	@GandalfLabel('Appointment Created')
	@GandalfProperty({ designType: Boolean })
	appointmentCreated!: boolean | null;

	@GandalfLabel('Appointment Date')
	@GandalfProperty({ designType: Date })
	appointmentDate!: Date | null;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Diagnosis')
	@GandalfProperty({ designType: Number })
	diagnosisId!: number | null;

	@GandalfLabel('Documents Provided')
	@GandalfProperty({ designType: Boolean })
	documentsProvided!: boolean | null;

	@GandalfLabel('Reason')
	@GandalfValidator({ notNull: { message: 'Reason is required' } })
	@GandalfValidator({ sizeString: { message: 'Reason must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	reason!: string;

	@GandalfLabel('Referral Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	referralDate!: Date;

	@GandalfLabel('Referral')
	@GandalfValidator({ notNull: { message: 'Referral is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	referralId!: number;

	@GandalfLabel('Referral Type')
	@GandalfProperty({ designType: Number })
	referralTypeId!: number | null;

	@GandalfLabel('Referred By')
	@GandalfValidator({ notNull: { message: 'Referred By is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	referredById!: number;

	@GandalfLabel('Referred To')
	@GandalfValidator({ notNull: { message: 'Referred To is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	referredToId!: number;

	@GandalfLabel('Response Comments')
	@GandalfValidator({ sizeString: { message: 'Response Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	responseComments!: string | null;

	@GandalfLabel('Response Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	responseDate!: Date | null;

	@GandalfLabel('Response Report Received')
	@GandalfProperty({ designType: Boolean })
	responseReportReceived!: boolean;

	@GandalfLabel('Response Request Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	responseRequestDate!: Date | null;

	@GandalfLabel('To Be Seen')
	@GandalfValidator({ sizeString: { message: 'To Be Seen cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	toBeSeen!: string | null;

}
